import { Injectable } from '@angular/core';
import { Util } from "../shared/util";

@Injectable({
  providedIn: 'root'
})
export class MeasureService {

  public get_filtered_measures(state: any) {
    const measures = Util.deepCopy(state.Meta.measures);
    const groups = Util.deepCopy(state.Groups);
    const location = state.Location;

    // Add Period to measure groups if Period is in the groups array
    if (groups.indexOf("Period") !== -1) {
      measures.forEach(m => {
        if (!!m.groups && m.groups.indexOf("Period") === -1) {
          m.groups = m.groups + ",Period";
        } else if (!m.groups) {
          m.groups = "Period";
        }
      });
    }

    // Add location to groups if provided and not already present
    if (!!location && !!location.length && location !== "NSW" && !!groups && groups.indexOf(location) === -1) {
      groups.push(location);
    }

    // Filter measures by matching groups
    const sortedGroupsAppliedOnTheUI = this.sort_groups_alphabetically(groups);
    const groupMeasures = measures.filter(m => !!groups && this.sort_groups_alphabetically(this.split_measure_groups_safely(m.groups)) === sortedGroupsAppliedOnTheUI);
    const filteredMeasures = !!groupMeasures && !!groupMeasures.length ? groupMeasures : measures;

    return filteredMeasures;
  }

  sort_groups_alphabetically(groups) {
    if (!!groups) {
      return groups.sort((a, b) => a.localeCompare(b)).join();
    }
    return "";
  }

  split_measure_groups_safely(measureGroups) {
    if (!!measureGroups) {
      if (measureGroups.indexOf(",") !== -1) {
        return measureGroups.split(",");
      }
      else {
        return [measureGroups];
      }
    }
    return [];
  }
}
